// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"ab7f8d5a","795":"616c33f6"}[chunkId] + ".chunk.js";
};